import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import * as NavUtil from '../../Utils/NavUtil';
import Theme from '../../Theme';
import * as AppActions from '../../AppActions';
import {Line} from '@styled-icons/fa-brands/Line';
import {FacebookSquare} from '@styled-icons/fa-brands/FacebookSquare';

export default function SiteFooter(props) {
  useOutlet('navbarConfig');
  const [about] = useOutlet('about');
  // const navItems = NavUtil.getNavItems(props);

  return (
    <Wrapper>
      <div className="content">
        <div className="row">
          <div className="left">
            <div className="logo-box">
              <img src="/images/site-logo.png" alt="Logo" />
              <div className="logo-text">
                <div className="main">社團法人台北市牙醫師公會</div>
                <div className="sub">Taipei Dental Association</div>
              </div>
            </div>
            <div style={{marginTop: 20}}>{about?.information?.address}</div>
            <div className="contact">
              <div>電話: {about?.information?.phone}</div>
              <div>傳真: {about?.information?.fax}</div>
              <div>信箱: {about?.information.mail}</div>
            </div>
            <div className="contact">
              <div>郵政劃撥帳號：01068925</div>
              <div>戶名：社團法人台北市牙醫師公會</div>
            </div>
          </div>
          <div className="right">
            <a
              target="_blank"
              href="https://facebook.com/120275868022597"
              rel="noreferrer">
              <FacebookSquare size={30} color="#fff" />
            </a>
            <a
              target="_blank"
              href="http://line.me/ti/p/E3m_fsOMYR"
              rel="noreferrer">
              <Line size={30} color="#fff" />
            </a>
          </div>
          {/* <div className="right">
            {navItems.map((it, idx) => {
              return (
                <div key={it.name} className="nav-items">
                  <h3>{it.name}</h3>
                  <ul>
                    {(it.entries || []).map((itt, idxx) => {
                      return (
                        <li key={itt.name}>
                          <a
                            href={itt.path}
                            onClick={(e) => {
                              e.preventDefault();
                              AppActions.navigate(itt.path);
                            }}>
                            {itt.name}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div> */}
        </div>

        <div className="bottom">
          <div>
            © 2015-{new Date().getFullYear()} 社團法人台北市牙醫師公會 Taipei
            Dental Association(TDA). All rights reserved.
          </div>
          <div>
            designed by <a href="https://www.revtel.tech/">忻旅科技</a>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: var(--primaryColor);
  color: rgba(256, 256, 256, 0.8);
  font-size: 14px;
  padding: 30px 0;

  .content {
    max-width: var(--contentMaxWidth);
    margin: 0 auto;

    .row {
      display: flex;
      flex-wrap: wrap;
      gap: 30px;

      .left {
        flex: 1 0 300px;
      }

      .right {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 10px;

        @media (max-width: 768px) {
        }
      }
    }

    .bottom {
      margin-top: 20px;
      color: rgba(256, 256, 256, 0.6);
      font-size: 12px;

      & a {
        color: rgba(256, 256, 256, 0.6);
      }
    }
  }

  .logo-box {
    display: flex;
    gap: 10px;
    img {
      width: 50px;
      height: 50px;
      object-fit: contain;
    }
    & > .logo-text {
      & > .main {
        font-size: 18px;
      }
    }
  }

  & .contact {
    display: flex;
    gap: 20px;
  }

  @media (max-width: ${Theme.maxWidth}px) {
    .content {
      padding: 0 15px;
    }
  }

  @media (max-width: ${Theme.breakpoint}px) {
    .contact {
      flex-direction: column;
      gap: 0;
    }
  }

  /* .nav-items {
    h3 {
      margin-bottom: 10px;
    }

    ul {
      padding: 0px;
      & > li {
        list-style-type: none;
        display: block;
        margin-bottom: 5px;
        a {
          color: #fff;
        }
      }
    }
  } */
`;
